var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "end" } },
        [
          _c(
            "el-button",
            {
              staticClass: "create-button",
              attrs: { type: "primary" },
              on: { click: _vm.openEventDialog },
            },
            [_vm._v(_vm._s(_vm.$t("Cuona.Event.new")))]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("EventsTable", {
            staticClass: "group",
            attrs: {
              events: _vm.events,
              edit: false,
              isGroupHidden: false,
              loading: _vm.isLoading,
              actions: _vm.actions,
            },
          }),
        ],
        1
      ),
      _c("event-dialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }